export const actions = {
  InitTheme: "InitTheme",
  ToggleTheme: "ToggleTheme",
  InitLayout: "InitLayout",
};
